import type { StatisticTheme } from './light'
import { commonDark } from '../../_styles/common'
import { self } from './light'

const statisticDark: StatisticTheme = {
  name: 'Statistic',
  common: commonDark,
  self
}

export default statisticDark
